// import ajax from '@/api/ajax'
const productID = 2

// 发送请求方法
function ajax(url, method, data, cb) {
    var xmlhttp;
    if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
    } else {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4) {
            if (xmlhttp.status !== 200) {
                console.log(xmlhttp.status + ':' + xmlhttp.statusText);
                cb(new Error(xmlhttp.status));
                return;
            }
            cb(null, xmlhttp.responseText);
            return;
        }
    }
    xmlhttp.open(method, url, true);
    if (method === 'POST') {
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    }
    if(data) {
        xmlhttp.send(data);
    }else {
        xmlhttp.send();
    }
}

const utils = {
    getQueryString: (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r;
        if(window.location.search){
             r = window.location.search.substr(1).match(reg);
        }
        if(window.location.hash.split('?').length>1) {
            r = window.location.hash.split('?')[1].match(reg);
        }

        if (r != null) return unescape(r[2]);
        return null;
    },
    //打点log
    sendLog: (qs, actionCode ,cb) => {
        let dotUrl = 'https://dotdata.knowbox.cn/data/data/dot-h5-log', param;
        let keys = [
            'appChannel',
            'pageCode',
            'pageFrom',
            'deviceType',
            'deviceVersion',
            'deviceID',
            'extensionJson'
        ];
        let data = [
            productID,
            qs.version || '',
            qs.source || '',
        ];
        keys.forEach(function(key) {
            let value = qs[key] || '';
            if(value && key== 'extensionJson'){
                value = typeof value === 'object' ? JSON.stringify(value) : value;
            }
            data.push(value)
        });
        data.push(actionCode);
        param = 'token=' + qs.token + '&source=' + qs.source + '&version=' + qs.version + '&data=' + data.join('|') + '&t=' + (+new Date);
        ajax(dotUrl, 'POST', param, function(err, res) {if(cb) cb()});
    }
}

export default utils